const nortonContainer = document.querySelector('.Shopping-Guarantee-Product');

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === 'childList') {
     const nortonFacade = document.querySelector(".norton-badge__container")
      
       nortonFacade.addEventListener('click', () => {
         const nortonEl = document.querySelector(".Shopping-Guarantee-Product img")
         nortonEl.click()
       })
    } 
  }
};

// Create an observer instance linked to the callback function
const NortonObserver = new MutationObserver(callback);

// Start observing the target node for configured mutations
NortonObserver.observe(nortonContainer, config);

// Later, you can stop observing
//observer.disconnect();